import palette from '../palette';

export default {
  indicator: {
    backgroundColor: palette.white,
  },
};
